module.exports = __webpack_public_path__ + "static/media/user-hard-hat.5d70f009.svg";